export enum PayServiceTypeEnum {
    None = 0,
    Cash = 1,
    PaymentCard = 2,
    ForCompany = 3,
    XpressUserWallet = 4,
    FullPromo = 5,
    RecipientPaysForDelivery = 6,
}
